import { IClientConfig } from 'core/types';

export const clientConfig: IClientConfig = {
  GOOGLE_CLIENT_ID:
    '669352062046-p8jrhojjtrd5ev5nko1ee639mviancs6.apps.googleusercontent.com',
  GOOGLE_TRACKING_CODE: 'G-7EBCQ6T2ZM',
  GOOGLE_TAG_MANAGER_ID: 'GTM-WPF9C37',
  apiPath: 'https://inside-admin.qa.eagle.auto1.team/v1/intranet',
  eagleApiUrl: 'https://inside-admin.qa.eagle.auto1.team/v1',
  host: 'https://inside-admin.qa.eagle.auto1.team',
  isProd: false,
  mockLogin: false, // always false
  peopleDirectoryHost: 'https://people.qa.intranet.auto1.cloud',
  tokenParamName: 't',
  eagleTokenParamName: 't',
};
